import { useDrawer } from '../hooks/useDrawer';

type OpenIconContainerProps = {
	handleClick: () => void;
};

const OpenIconContainer = ({ handleClick }: OpenIconContainerProps) => {
	const { blockClass } = useDrawer();

	const renderClass = (compName: string) =>
		blockClass && `vtex-store-drawer-0-x-${compName}--${blockClass} ${compName}--${blockClass}`;

	return (
		<div
			className={`pa4 pointer vtex-store-drawer-0-x-openIconContainer openIconContainer ${renderClass('openIconContainer')}`}
			onClick={() => handleClick()}
		>
			<svg
				fill="none"
				width="20"
				height="20"
				viewBox="0 0 16 16"
				className={`vtex-store-drawer-0-x-menuIcon menuIcon ${renderClass('menuIcon')}`}
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="hpa-hamburguer-menu">
					<path fill="#000000" d="M15,7H1C0.4,7,0,7.4,0,8s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,7,15,7z"></path>
					<path fill="#000000" d="M15,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,1,15,1z"></path>
					<path fill="#000000" d="M15,13H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h14c0.6,0,1-0.4,1-1S15.6,13,15,13z"></path>
				</g>
			</svg>
		</div>
	);
};

export default OpenIconContainer;
